import loadable from '@wix/yoshi-flow-editor/loadable'

export const SeatingPlanModal = loadable(
  () => import(/* webpackPrefetch: true, webpackChunkName: "seating-plan-modal" */ '../modals/seating-plan'),
)
